import type { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement>;

function IconBase({ children, ...props }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      {children}
    </svg>
  );
}

export const SessionIcon = (props: IconProps) => (
  <IconBase {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="M7 12h2l1.2-4 3 8 1.4-4H17" />
  </IconBase>
);

export const DeviceIcon = (props: IconProps) => (
  <IconBase {...props}>
    <rect x="6" y="2.5" width="12" height="19" rx="2.5" />
    <path d="M10 18.5h4" />
  </IconBase>
);

export const HistoryIcon = (props: IconProps) => (
  <IconBase {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3.5 2" />
  </IconBase>
);

export const SafetyIcon = (props: IconProps) => (
  <IconBase {...props}>
    <path d="M12 2.7 20 6v5.4c0 5.1-3.4 8.3-8 10-4.6-1.7-8-4.9-8-10V6l8-3.3Z" />
    <path d="m8.7 12.2 2.1 2.1 4.5-4.7" />
  </IconBase>
);

export const PersonIcon = (props: IconProps) => (
  <IconBase {...props}>
    <circle cx="12" cy="8" r="3.4" />
    <path d="M5.5 21c.4-4 2.6-6 6.5-6s6.1 2 6.5 6" />
  </IconBase>
);

export const LockIcon = (props: IconProps) => (
  <IconBase {...props}>
    <rect x="5" y="10" width="14" height="11" rx="2" />
    <path d="M8 10V7a4 4 0 0 1 8 0v3" />
  </IconBase>
);

export const BluetoothIcon = (props: IconProps) => (
  <IconBase {...props}>
    <path d="m8 7 8 10V7l-8 10 8-10-4-4v18l4-4" />
  </IconBase>
);

export const StopIcon = (props: IconProps) => (
  <IconBase {...props}>
    <path d="M8.3 3h7.4L21 8.3v7.4L15.7 21H8.3L3 15.7V8.3L8.3 3Z" />
    <path d="M9 9h6v6H9z" />
  </IconBase>
);

export const CheckIcon = (props: IconProps) => (
  <IconBase {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="m8 12 2.6 2.6L16.5 9" />
  </IconBase>
);

export const EyeIcon = (props: IconProps) => (
  <IconBase {...props}>
    <path d="M2.5 12S6 6.5 12 6.5 21.5 12 21.5 12 18 17.5 12 17.5 2.5 12 2.5 12Z" />
    <circle cx="12" cy="12" r="2.5" />
  </IconBase>
);

export const LogOutIcon = (props: IconProps) => (
  <IconBase {...props}>
    <path d="M10 4H5v16h5" />
    <path d="m14 8 4 4-4 4M8 12h10" />
  </IconBase>
);

export const InfoIcon = (props: IconProps) => (
  <IconBase {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 11v5M12 8h.01" />
  </IconBase>
);
